/**
 * Manufacturing Structures and their bonuses
 *
 * Based on in-game structure data from Eve Echoes
 * Note: Citadel bonuses vary by item category (ships, modules, etc.)
 */

export interface StructureDefinition {
  id: string;
  name: string;
  category: 'citadel' | 'workshop' | 'factory';
  description?: string;
}

/**
 * Available manufacturing structures
 * Users will specify the actual ME bonus when adding them
 */
export const STRUCTURES: StructureDefinition[] = [
  // Citadels
  {
    id: 'corp_citadel_i',
    name: 'Corporation Citadel I',
    category: 'citadel',
    description: 'Bonus varies by item type (1-5%)',
  },
  {
    id: 'corp_citadel_ii',
    name: 'Corporation Citadel II',
    category: 'citadel',
    description: 'Bonus varies by item type',
  },
  {
    id: 'corp_citadel_iii',
    name: 'Corporation Citadel III',
    category: 'citadel',
    description: 'Bonus varies by item type',
  },

  // Workshops
  {
    id: 'assembly_workshop_i',
    name: 'Assembly Workshop I',
    category: 'workshop',
    description: 'Small ships and modules',
  },
  {
    id: 'assembly_workshop_ii',
    name: 'Assembly Workshop II',
    category: 'workshop',
    description: 'Small ships and modules',
  },
  {
    id: 'assembly_workshop_iii',
    name: 'Assembly Workshop III',
    category: 'workshop',
    description: 'Small ships and modules (6% ME)',
  },

  // Factories
  {
    id: 'capital_ship_parts_factory_i',
    name: 'Capital Ship Parts Factory I',
    category: 'factory',
    description: 'Capital components',
  },
  {
    id: 'capital_ship_parts_factory_ii',
    name: 'Capital Ship Parts Factory II',
    category: 'factory',
    description: 'Capital components',
  },
  {
    id: 'capital_ship_parts_factory_iii',
    name: 'Capital Ship Parts Factory III',
    category: 'factory',
    description: 'Capital components (6% ME)',
  },
  {
    id: 'capital_ship_assembly_i',
    name: 'Capital Ship Assembly I',
    category: 'factory',
    description: 'Capital ships',
  },
  {
    id: 'capital_ship_assembly_ii',
    name: 'Capital Ship Assembly II',
    category: 'factory',
    description: 'Capital ships',
  },
  {
    id: 'capital_ship_assembly_iii',
    name: 'Capital Ship Assembly III',
    category: 'factory',
    description: 'Capital ships (6% ME)',
  },
  {
    id: 'ship_assembly_i',
    name: 'Ship Assembly I',
    category: 'factory',
    description: 'Subcapital ships',
  },
  {
    id: 'ship_assembly_ii',
    name: 'Ship Assembly II',
    category: 'factory',
    description: 'Subcapital ships',
  },
  {
    id: 'ship_assembly_iii',
    name: 'Ship Assembly III',
    category: 'factory',
    description: 'Subcapital ships (6% ME)',
  },
  {
    id: 'module_assembly_i',
    name: 'Module Assembly I',
    category: 'factory',
    description: 'Modules and equipment',
  },
  {
    id: 'module_assembly_ii',
    name: 'Module Assembly II',
    category: 'factory',
    description: 'Modules and equipment',
  },
  {
    id: 'module_assembly_iii',
    name: 'Module Assembly III',
    category: 'factory',
    description: 'Modules and equipment (6% ME)',
  },
];

/**
 * Get structure by ID
 */
export function getStructureById(id: string): StructureDefinition | undefined {
  return STRUCTURES.find((s) => s.id === id);
}
